module.exports = __webpack_public_path__ + "static/img/home_type_icon_hydcx.5fe3c2a1.webp";